import type { NotificationField } from '../types'

function customizedLabel(value: string, fallback: string) {
  return value.trim() ? value : fallback
}

/**
 * Resolves the approvals-field vocabulary used by notification conditions.
 *
 * Missing or disabled custom labels use the default option nouns.
 */
export function approvalFieldSettings(field: NotificationField | undefined) {
  if (field?.settings.type !== 'approvals')
    return { plural: 'Options', single: false, singular: 'Option' }

  const { customizeOptionLabel, single } = field.settings
  if (!customizeOptionLabel?.enabled)
    return {
      plural: 'Options',
      single,
      singular: 'Option',
    }

  return {
    plural: customizedLabel(customizeOptionLabel.plural, 'Options'),
    single,
    singular: customizedLabel(customizeOptionLabel.singular, 'Option'),
  }
}
